<template>
	<div class="mainView">
		<headerView class="header" currentMenu='schemaDetail'></headerView>
		<div class="header-bg-div"></div>
		<div class="content">
			<contentDetail ref="contentDetail"></contentDetail>
		</div>
	</div>
</template>

<script>
// import pdf from 'vue-pdf'

import headerView from '@/components/main/headerView.vue'
import contentDetail from '../../components/content/contentDetail.vue'
import { getQueryString } from '@/utils'
// import Compressor from 'compressorjs'

export default {
	name: 'appCommonPdf',
	props: {
		pdfUrl: {
		type: String,
			default: ''
		}
	},
	components: {
		// pdf
		headerView,
		contentDetail
	},
	data () {
		return {
		}
	},
	mounted () {
		// console.log(this.myPdf);
		// this.getPdfList();
		console.log($('#imgDiv'));
		this.getDataDetail();
	},
	methods: {
		getDataDetail () {
			let sourceId = getQueryString('bookId');
			let bookType = getQueryString('bookType');
			let schemaType = getQueryString('schemaType');
			this.$refs.contentDetail.getDataDetail(sourceId, bookType, schemaType);
			// this.$refs.contentDetail.getDataDetail(sourceId);
			this.$refs.contentDetail.getSchemaDetail(sourceId, bookType);
			this.$refs.contentDetail.getPicDetail(sourceId, bookType);
			this.$refs.contentDetail.getPersonDetail(sourceId, bookType);
			this.$refs.contentDetail.getEventDetail(sourceId, bookType);
			this.$refs.contentDetail.getOrgDetail(sourceId, bookType);
			this.$refs.contentDetail.getGeoDetail(sourceId, bookType);
		}
	}
}
</script>

<style lang='less' scoped>
@import "~@/styles/variables.less";
.mainView {
	width: 100%;
	height: 100%;

	.header {
		width: 100%;
		height: 80 * @uh;
		z-index: 10;
		background: rgba(248, 248, 248, 0.7);
		position: relative;
		color: #8d5e1a;
	}

	.header-bg-div {
		position: absolute;
		left: 0px;
		top: 0px;
		width: 1910 * @uw;
		height: 80 * @uh;
		background-image: url('~@/assets/images/main/header.jpg');
    	background-size: 100% 130%;
		z-index: 0;
	}

	.title {
		width: 520 * @uw;
		height: 40 * @uh;
		font-size: 40 * @uw;
		margin-left: 700 * @uw;
		position: relative;
		margin-top: 80 * @uh;
		color: #430a00;
	}

	.book-chart-div {
		width: 1200 * @uw;
		height: 482 * @uh;
		margin-top: 60 * @uh;
		margin-left: 360 * @uw;
		box-shadow: 0px 0px 10px 5px #e0e0e0;
	}

	.content {
		width: 1200 * @uw;
		height: auto;
		display: flex;
		justify-content: space-between;
		margin-left: 360 * @uw;
		margin-top: 30 * @uh;
	}
}
</style>
